import { cn } from "@/lib/utils"

// The ★ rating unit, rendered inline after a value (metric rating/gap rows and
// platform ratings). Layout classes (margin, display) are caller-controlled via
// className so each call site keeps its own spacing and alignment. Grey, not
// gold: in File data only a "vs portfolio" delta carries colour.
export const StarUnit = ({ className }: { className?: string }) => (
  <svg
    width="11"
    height="11"
    viewBox="0 0 12 12"
    className={cn("align-middle", className)}
    aria-hidden="true"
  >
    <polygon
      points="6,1 7.5,4.5 11,5 8.5,7.5 9,11 6,9.2 3,11 3.5,7.5 1,5 4.5,4.5"
      className="fill-muted-foreground"
    />
  </svg>
)
